import cloneDeep from 'lodash/cloneDeep';
import { initialState } from './initialState';

export const ACTION = {
  FIRM_DATA_REQUEST: 'FIRM_DATA_REQUEST',
  FIRM_DATA_SUCCESS: 'FIRM_DATA_SUCCESS',
  FIRM_REVIEWS_REQUEST: 'FIRM_REVIEWS_REQUEST',
  FIRM_REVIEWS_SUCCESS: 'FIRM_REVIEWS_SUCCESS',
  FIRM_REVIEWS_SORT_CHANGE: 'FIRM_REVIEWS_SORT_CHANGE',
  FIRM_REVIEW_UPDATE: 'FIRM_REVIEW_UPDATE',
  FIRM_RATING_UPDATE: 'FIRM_RATING_UPDATE',
  FIRM_PORTFOLIO_ITEM_MARK_UPDATE_REQUEST:
    'FIRM_PORTFOLIO_ITEM_MARK_UPDATE_REQUEST',
  FIRM_PORTFOLIO_ITEM_MARK_UPDATE_SUCCESS:
    'FIRM_PORTFOLIO_ITEM_MARK_UPDATE_SUCCESS',
  FIRM_TOGGLE_EDIT_MODE: 'FIRM_TOGGLE_EDIT_MODE',
  FIRM_PHOTO_TOGGLE_TAB_ACTIVE_REQUEST: 'FIRM_PHOTO_TOGGLE_TAB_ACTIVE_REQUEST',
  FIRM_PHOTO_TOGGLE_TAB_ACTIVE_SUCCESS: 'FIRM_PHOTO_TOGGLE_TAB_ACTIVE_SUCCESS',
  FIRM_PHOTO_TOGGLE_TAB_ACTIVE_FAIL: 'FIRM_PHOTO_TOGGLE_TAB_ACTIVE_FAIL',

  FIRM_ABOUT_DESCRIPTION_BLOCK_SAVE: 'FIRM_ABOUT_DESCRIPTION_BLOCK_SAVE',
  FIRM_ABOUT_DESCRIPTION_BLOCK_DELETE_REQUEST:
    'FIRM_ABOUT_DESCRIPTION_BLOCK_DELETE_REQUEST',
  FIRM_ABOUT_DESCRIPTION_BLOCK_DELETE_FAIL:
    'FIRM_ABOUT_DESCRIPTION_BLOCK_DELETE_FAIL',
  FIRM_ABOUT_DESCRIPTION_BLOCK_DELETE_SUCCESS:
    'FIRM_ABOUT_DESCRIPTION_BLOCK_DELETE_SUCCESS',

  FIRM_ABOUT_DESCRIPTION_SUBBLOCK_ADD: 'FIRM_ABOUT_DESCRIPTION_SUBBLOCK_ADD',
  FIRM_ABOUT_DESCRIPTION_SUBBLOCK_UPDATE:
    'FIRM_ABOUT_DESCRIPTION_SUBBLOCK_UPDATE',
  FIRM_ABOUT_DESCRIPTION_SUBBLOCK_DELETE_REQUEST:
    'FIRM_ABOUT_DESCRIPTION_SUBBLOCK_DELETE_REQUEST',
  FIRM_ABOUT_DESCRIPTION_SUBBLOCK_DELETE_FAIL:
    'FIRM_ABOUT_DESCRIPTION_SUBBLOCK_DELETE_FAIL',
  FIRM_ABOUT_DESCRIPTION_SUBBLOCK_DELETE_SUCCESS:
    'FIRM_ABOUT_DESCRIPTION_SUBBLOCK_DELETE_SUCCESS',

  FIRM_PHOTO_TOGGLE_SORTING_MODE: 'FIRM_PHOTO_TOGGLE_SORTING_MODE',
  FIRM_PHOTO_DELETE_REQUEST: 'FIRM_PHOTO_DELETE_REQUEST',
  FIRM_PHOTO_DELETE_SUCCESS: 'FIRM_PHOTO_DELETE_SUCCESS',
  FIRM_PHOTO_UPLOAD_SUCCESS: 'FIRM_PHOTO_UPLOAD_SUCCESS',
  FIRM_PHOTO_SORTING: 'FIRM_PHOTO_SORTING',
  FIRM_ABOUT_AWARDS_BLOCK_SAVE: 'FIRM_ABOUT_AWARDS_BLOCK_SAVE',
  FIRM_ABOUT_AWARDS_BLOCK_DELETE_REQUEST:
    'FIRM_ABOUT_AWARDS_BLOCK_DELETE_REQUEST',
  FIRM_ABOUT_AWARDS_BLOCK_DELETE_FAIL: 'FIRM_ABOUT_AWARDS_BLOCK_DELETE_FAIL',
  FIRM_ABOUT_AWARDS_BLOCK_DELETE_SUCCESS:
    'FIRM_ABOUT_AWARDS_BLOCK_DELETE_SUCCESS',
  FIRM_STRATEGY_FUND_HISTORY_CREATE: 'FIRM_STRATEGY_FUND_HISTORY_CREATE',
  FIRM_STRATEGY_FUND_HISTORY_UPDATE: 'FIRM_STRATEGY_FUND_HISTORY_UPDATE',
  FIRM_STRATEGY_FUND_HISTORY_DELETE_REQUEST:
    'FIRM_STRATEGY_FUND_HISTORY_DELETE_REQUEST',
  FIRM_STRATEGY_FUND_HISTORY_DELETE_FAIL:
    'FIRM_STRATEGY_FUND_HISTORY_DELETE_FAIL',
  FIRM_STRATEGY_FUND_HISTORY_DELETE_SUCCESS:
    'FIRM_STRATEGY_FUND_HISTORY_DELETE_SUCCESS',

  FIRM_STRATEGY_INVESTMENT_STRATEGY_UPDATE:
    'FIRM_STRATEGY_INVESTMENT_STRATEGY_UPDATE',
  FIRM_STRATEGY_INVESTMENT_STRATEGY_DELETE_REQUEST:
    'FIRM_STRATEGY_INVESTMENT_STRATEGY_DELETE_REQUEST',
  FIRM_STRATEGY_INVESTMENT_STRATEGY_DELETE_FAIL:
    'FIRM_STRATEGY_INVESTMENT_STRATEGY_DELETE_FAIL',
  FIRM_STRATEGY_INVESTMENT_STRATEGY_DELETE_SUCCESS:
    'FIRM_STRATEGY_INVESTMENT_STRATEGY_DELETE_SUCCESS',

  FIRM_PORTFOLIO_CRITERIA_UPDATE: 'FIRM_PORTFOLIO_CRITERIA_UPDATE',
  FIRM_PORTFOLIO_ITEM_ADD: 'FIRM_PORTFOLIO_ITEM_ADD',
  FIRM_PORTFOLIO_ITEM_UPDATE: 'FIRM_PORTFOLIO_ITEM_UPDATE',
  FIRM_PORTFOLIO_ITEM_DELETE_REQUEST: 'FIRM_PORTFOLIO_ITEM_DELETE_REQUEST',
  FIRM_PORTFOLIO_ITEM_DELETE_FAIL: 'FIRM_PORTFOLIO_ITEM_DELETE_FAIL',
  FIRM_PORTFOLIO_ITEM_DELETE_SUCCESS: 'FIRM_PORTFOLIO_ITEM_DELETE_SUCCESS',

  FIRM_OVERVIEW_UPDATE: 'FIRM_OVERVIEW_UPDATE',
  FIRM_LOGO_UPDATE: 'FIRM_LOGO_UPDATE',

  CANDIDATES_ALSO_VIEWED_FIRM_RATING_UPDATE_REQUEST:
    'CANDIDATES_ALSO_VIEWED_FIRM_RATING_UPDATE_REQUEST',
  CANDIDATES_ALSO_VIEWED_FIRM_RATING_UPDATE_SUCCESS:
    'CANDIDATES_ALSO_VIEWED_FIRM_RATING_UPDATE_SUCCESS',
  CANDIDATES_ALSO_VIEWED_FIRM_RATING_UPDATE_FAIL:
    'CANDIDATES_ALSO_VIEWED_FIRM_RATING_UPDATE_FAIL',

  FIRM_PORTFOLIO_GRID_REQUEST: 'FIRM_PORTFOLIO_GRID_REQUEST',
  FIRM_PORTFOLIO_GRID_SUCCESS: 'FIRM_PORTFOLIO_GRID_SUCCESS',

  FIRM_PORTFOLIO_COMMENTS_REQUEST: 'FIRM_PORTFOLIO_COMMENTS_REQUEST',
  FIRM_PORTFOLIO_COMMENTS_SUCCESS: 'FIRM_PORTFOLIO_COMMENTS_SUCCESS',
  FIRM_PORTFOLIO_COMMENTS_FAIL: 'FIRM_PORTFOLIO_COMMENTS_FAIL',

  FIRM_PORTFOLIO_ADD_COMMENT_REQUEST: 'FIRM_PORTFOLIO_ADD_COMMENT_REQUEST',
  FIRM_PORTFOLIO_ADD_COMMENT_SUCCESS: 'FIRM_PORTFOLIO_ADD_COMMENT_SUCCESS',
  FIRM_PORTFOLIO_ADD_COMMENT_FAIL: 'FIRM_PORTFOLIO_ADD_COMMENT_FAIL',

  FIRM_PORTFOLIO_REMOVE_COMMENT_REQUEST:
    'FIRM_PORTFOLIO_REMOVE_COMMENT_REQUEST',
  FIRM_PORTFOLIO_REMOVE_COMMENT_SUCCESS:
    'FIRM_PORTFOLIO_REMOVE_COMMENT_SUCCESS',
  FIRM_PORTFOLIO_REMOVE_COMMENT_FAIL: 'FIRM_PORTFOLIO_REMOVE_COMMENT_FAIL',

  FIRM_REVIEW_COMMENTS_REQUEST: 'FIRM_REVIEW_COMMENTS_REQUEST',
  FIRM_REVIEW_COMMENTS_SUCCESS: 'FIRM_REVIEW_COMMENTS_SUCCESS',
  FIRM_REVIEW_COMMENTS_FAIL: 'FIRM_REVIEW_COMMENTS_FAIL',

  FIRM_REVIEW_ADD_COMMENT_REQUEST: 'FIRM_REVIEW_ADD_COMMENT_REQUEST',
  FIRM_REVIEW_ADD_COMMENT_SUCCESS: 'FIRM_REVIEW_ADD_COMMENT_SUCCESS',
  FIRM_REVIEW_ADD_COMMENT_FAIL: 'FIRM_REVIEW_ADD_COMMENT_FAIL',

  FIRM_REVIEW_REMOVE_COMMENT_REQUEST: 'FIRM_REVIEW_REMOVE_COMMENT_REQUEST',
  FIRM_REVIEW_REMOVE_COMMENT_SUCCESS: 'FIRM_REVIEW_REMOVE_COMMENT_SUCCESS',
  FIRM_REVIEW_REMOVE_COMMENT_FAIL: 'FIRM_REVIEW_REMOVE_COMMENT_FAIL',
};

export const reducer = (state, action) => {
  const { type, data } = action;

  switch (type) {
    case ACTION.FIRM_DATA_REQUEST:
      return cloneDeep(initialState);

    case ACTION.FIRM_DATA_SUCCESS: {
      if (!data.tabs.about.data) {
        data.tabs.about.data = cloneDeep(initialState.tabs.about.data);
      } else if (data.tabs.about.data.photosBlock) {
        data.tabs.about.data.photosBlock = data.tabs.about.data.photosBlock.map(
          p => ({
            ...p,
            width: 1,
            height: 1,
          })
        );
      }

      data.nav = initialState.nav
        .filter(t => data.tabs.hasOwnProperty(t.alias) || t.isPinned)
        .map(t => {
          return {
            ...t,
            isActive: t.isPinned
              ? true
              : data.tabs.hasOwnProperty(t.alias) &&
                data.tabs[t.alias].isActive,
          };
        });

      return {
        ...state,
        init: true,
        ...data,
        tabs: {
          ...data.tabs,
        },
      };
    }

    case ACTION.FIRM_TOGGLE_EDIT_MODE: {
      return {
        ...state,
        isEditMode: data,
      };
    }

    case ACTION.FIRM_PHOTO_TOGGLE_TAB_ACTIVE_REQUEST: {
      return {
        ...state,
        nav: state.nav.map(t =>
          t.alias === data.alias
            ? { ...t, isDisabled: true, isActive: data.isActive }
            : t
        ),
      };
    }

    case ACTION.FIRM_PHOTO_TOGGLE_TAB_ACTIVE_SUCCESS: {
      return {
        ...state,
        nav: state.nav.map(t =>
          t.alias === data.alias ? { ...t, isDisabled: false } : t
        ),
        tabs: {
          ...state.tabs,
          [data.alias]: {
            ...state.tabs[data.alias],
            isActive: data.isActive,
          },
        },
      };
    }

    case ACTION.FIRM_PHOTO_TOGGLE_TAB_ACTIVE_FAIL: {
      return {
        ...state,
        nav: state.nav.map(t =>
          t.alias === data.alias
            ? { ...t, isDisabled: false, isActive: !data.isActive }
            : t
        ),
        tabs: {
          ...state.tabs,
          [data.alias]: {
            ...state.tabs[data.alias],
            isActive: !data.isActive,
          },
        },
      };
    }

    case ACTION.FIRM_PHOTO_TOGGLE_SORTING_MODE: {
      return {
        ...state,
        isPhotosSortable: data,
      };
    }

    case ACTION.FIRM_REVIEWS_REQUEST:
      return {
        ...state,
        tabs: {
          ...state.tabs,
          reviews: {
            rows: [],
            page: 0,
            rowsCount: 0,
            pagesCount: 0,
            perPage: 0,
            firmsCount: 0,
          },
        },
      };

    case ACTION.FIRM_REVIEWS_SUCCESS:
      return {
        ...state,
        tabs: {
          ...state.tabs,
          reviews: {
            ...state.tabs.reviews,
            data: { ...data },
          },
        },
      };

    case ACTION.FIRM_REVIEWS_SORT_CHANGE:
      return {
        ...state,
        reviewsSortBy: data,
      };

    case ACTION.FIRM_REVIEW_UPDATE:
      return {
        ...state,
        tabs: {
          ...state.tabs,
          reviews: {
            ...state.tabs.reviews,
            data: {
              ...state.tabs.reviews.data,
              rows: state.tabs.reviews.data.rows.map(record => {
                if (record.ReviewID !== data.ReviewID) {
                  return record;
                }
                return { ...record, ...data };
              }),
            },
          },
        },
      };

    case ACTION.FIRM_RATING_UPDATE: {
      const { responseData, value } = data;
      return {
        ...state,
        firm: {
          ...state.firm,
          ...responseData,
          FirmCandidateRating: value,
          ShowRating: true,
        },
      };
    }

    case ACTION.FIRM_PHOTO_DELETE_REQUEST: {
      if (state.tabs.about.data.photosBlock) {
        state.tabs.about.data.photosBlock = state.tabs.about.data.photosBlock.map(
          p =>
            Number(p.id) === Number(data)
              ? {
                  ...p,
                  disabled: true,
                }
              : p
        );
      }

      return { ...state };
    }

    case ACTION.FIRM_PHOTO_DELETE_SUCCESS: {
      if (state.tabs.about.data.photosBlock) {
        state.tabs.about.data.photosBlock = state.tabs.about.data.photosBlock.filter(
          p => Number(p.id) !== Number(data)
        );
      }

      return { ...state };
    }

    case ACTION.FIRM_PHOTO_UPLOAD_SUCCESS: {
      if (
        state.tabs.about.data.photosBlock &&
        state.tabs.about.data.photosBlock
      ) {
        state.tabs.about.data.photosBlock = [
          ...state.tabs.about.data.photosBlock,
          { ...data, width: 1, height: 1 },
        ];
      }

      return { ...state };
    }

    case ACTION.FIRM_PHOTO_SORTING: {
      if (
        state.tabs.about.data.photosBlock &&
        state.tabs.about.data.photosBlock
      ) {
        state.tabs.about.data.photosBlock = [...data];
      }

      return { ...state };
    }

    case ACTION.FIRM_ABOUT_DESCRIPTION_BLOCK_SAVE: {
      state.tabs.about.data.descriptionBlock = {
        ...state.tabs.about.data.descriptionBlock,
        ...data,
      };
      return { ...state };
    }

    case ACTION.FIRM_ABOUT_DESCRIPTION_BLOCK_DELETE_REQUEST: {
      state.tabs.about.data.descriptionBlock = {
        ...state.tabs.about.data.descriptionBlock,
        disabled: true,
      };
      return { ...state };
    }

    case ACTION.FIRM_ABOUT_DESCRIPTION_BLOCK_DELETE_FAIL: {
      state.tabs.about.data.descriptionBlock = {
        ...state.tabs.about.data.descriptionBlock,
        disabled: false,
      };
      return { ...state };
    }

    case ACTION.FIRM_ABOUT_DESCRIPTION_BLOCK_DELETE_SUCCESS: {
      delete state.tabs.about.data.descriptionBlock;
      return { ...state };
    }

    case ACTION.FIRM_ABOUT_DESCRIPTION_SUBBLOCK_ADD: {
      state.tabs.about.data.descriptionSubBlocks = state.tabs.about.data
        .descriptionSubBlocks
        ? [...state.tabs.about.data.descriptionSubBlocks, data]
        : [data];
      return { ...state };
    }

    case ACTION.FIRM_ABOUT_DESCRIPTION_SUBBLOCK_UPDATE: {
      state.tabs.about.data.descriptionSubBlocks = state.tabs.about.data.descriptionSubBlocks.map(
        b =>
          Number(b.FirmInfoBlockID) === Number(data.FirmInfoBlockID)
            ? {
                ...data,
              }
            : b
      );
      return { ...state };
    }

    case ACTION.FIRM_ABOUT_DESCRIPTION_SUBBLOCK_DELETE_REQUEST: {
      state.tabs.about.data.descriptionSubBlocks = state.tabs.about.data.descriptionSubBlocks.map(
        b =>
          Number(b.FirmInfoBlockID) === Number(data)
            ? { ...b, disabled: true }
            : b
      );
      return { ...state };
    }

    case ACTION.FIRM_ABOUT_DESCRIPTION_SUBBLOCK_DELETE_FAIL: {
      state.tabs.about.data.descriptionSubBlocks = state.tabs.about.data.descriptionSubBlocks.map(
        b =>
          Number(b.FirmInfoBlockID) === Number(data)
            ? { ...b, disabled: false }
            : b
      );
      return { ...state };
    }

    case ACTION.FIRM_ABOUT_DESCRIPTION_SUBBLOCK_DELETE_SUCCESS: {
      state.tabs.about.data.descriptionSubBlocks = state.tabs.about.data.descriptionSubBlocks.filter(
        b => Number(b.FirmInfoBlockID) !== Number(data)
      );
      return { ...state };
    }

    case ACTION.FIRM_ABOUT_AWARDS_BLOCK_SAVE: {
      state.tabs.about.data.awardsBlock = {
        ...state.tabs.about.data.awardsBlock,
        ...data,
      };
      return { ...state };
    }

    case ACTION.FIRM_ABOUT_AWARDS_BLOCK_DELETE_REQUEST: {
      state.tabs.about.data.awardsBlock = {
        ...state.tabs.about.data.awardsBlock,
        disabled: true,
      };
      return { ...state };
    }

    case ACTION.FIRM_ABOUT_AWARDS_BLOCK_DELETE_FAIL: {
      state.tabs.about.data.awardsBlock = {
        ...state.tabs.about.data.awardsBlock,
        disabled: false,
      };
      return { ...state };
    }

    case ACTION.FIRM_ABOUT_AWARDS_BLOCK_DELETE_SUCCESS: {
      delete state.tabs.about.data.awardsBlock;
      return { ...state };
    }

    case ACTION.FIRM_STRATEGY_FUND_HISTORY_CREATE: {
      state.tabs.strategy.data.funds = [
        ...state.tabs.strategy.data.funds,
        data,
      ];
      return { ...state };
    }

    case ACTION.FIRM_STRATEGY_FUND_HISTORY_UPDATE: {
      state.tabs.strategy.data.funds = state.tabs.strategy.data.funds.map(b =>
        Number(b.FirmFundHistoryID) === Number(data.FirmFundHistoryID)
          ? {
              ...data,
            }
          : b
      );
      return { ...state };
    }

    case ACTION.FIRM_STRATEGY_FUND_HISTORY_DELETE_REQUEST: {
      state.tabs.strategy.data.funds = state.tabs.strategy.data.funds.map(b =>
        Number(b.FirmFundHistoryID) === Number(data)
          ? {
              ...b,
              disabled: true,
            }
          : b
      );
      return { ...state };
    }

    case ACTION.FIRM_STRATEGY_FUND_HISTORY_DELETE_FAIL: {
      state.tabs.strategy.data.funds = state.tabs.strategy.data.funds.map(b =>
        Number(b.FirmFundHistoryID) === Number(data)
          ? {
              ...b,
              disabled: false,
            }
          : b
      );
      return { ...state };
    }

    case ACTION.FIRM_STRATEGY_FUND_HISTORY_DELETE_SUCCESS: {
      state.tabs.strategy.data.funds = state.tabs.strategy.data.funds.filter(
        b => Number(b.FirmFundHistoryID) !== Number(data)
      );
      return { ...state };
    }

    case ACTION.FIRM_STRATEGY_INVESTMENT_STRATEGY_UPDATE: {
      state.tabs.strategy.data.investment = data;
      return { ...state };
    }

    case ACTION.FIRM_STRATEGY_INVESTMENT_STRATEGY_DELETE_REQUEST: {
      state.tabs.strategy.data.investment = {
        ...state.tabs.strategy.data.investment,
        disabled: true,
      };
      return { ...state };
    }

    case ACTION.FIRM_STRATEGY_INVESTMENT_STRATEGY_DELETE_FAIL: {
      state.tabs.strategy.data.investment = {
        ...state.tabs.strategy.data.investment,
        disabled: false,
      };
      return { ...state };
    }

    case ACTION.FIRM_STRATEGY_INVESTMENT_STRATEGY_DELETE_SUCCESS: {
      delete state.tabs.strategy.data.investment;
      return { ...state };
    }

    case ACTION.FIRM_PORTFOLIO_ITEM_MARK_UPDATE_REQUEST: {
      const { PortfolioID, Type } = data;

      state.tabs.portfolio.data[
        Type.toLowerCase()
      ].rows = state.tabs.portfolio.data[Type.toLowerCase()].rows.map(f =>
        f.PortfolioID === PortfolioID ? { ...f, disabled: true } : f
      );

      return {
        ...state,
      };
    }

    case ACTION.FIRM_PORTFOLIO_ITEM_MARK_UPDATE_SUCCESS: {
      const { PortfolioID, Type, responseData } = data;

      state.tabs.portfolio.data[
        Type.toLowerCase()
      ].rows = state.tabs.portfolio.data[Type.toLowerCase()].rows.map(f =>
        f.PortfolioID === PortfolioID
          ? { ...f, disabled: false, ...responseData }
          : f
      );

      return {
        ...state,
      };
    }

    case ACTION.FIRM_PORTFOLIO_CRITERIA_UPDATE: {
      state.tabs.portfolio.data.criteria = { ...data };
      return { ...state };
    }

    case ACTION.FIRM_PORTFOLIO_ITEM_ADD: {
      const gridName = data.Type === 'Current' ? 'current' : 'realized';
      state.tabs.portfolio.data[gridName] = [
        { ...data },
        ...state.tabs.portfolio.data[gridName],
      ];
      return { ...state };
    }

    case ACTION.FIRM_PORTFOLIO_ITEM_UPDATE: {
      state.tabs.portfolio.data[
        data.Type.toLowerCase()
      ].rows = state.tabs.portfolio.data[data.Type.toLowerCase()].rows.map(b =>
        Number(b.PortfolioID) === Number(data.PortfolioID)
          ? {
              ...data,
              Comments: b.Comments ? b.Comments : [],
              CommentsCount: b.CommentsCount ? b.CommentsCount : 0,
            }
          : b
      );
      return { ...state };
    }

    case ACTION.FIRM_PORTFOLIO_ITEM_DELETE_REQUEST: {
      state.tabs.portfolio.data[
        data.Type.toLowerCase()
      ].rows = state.tabs.portfolio.data[data.Type.toLowerCase()].rows.map(b =>
        Number(b.PortfolioID) === Number(data)
          ? {
              ...b,
              disabled: true,
            }
          : b
      );
      return { ...state };
    }

    case ACTION.FIRM_PORTFOLIO_ITEM_DELETE_FAIL: {
      state.tabs.portfolio.data[
        data.Type.toLowerCase()
      ].rows = state.tabs.portfolio.data[data.Type.toLowerCase()].rows.map(b =>
        Number(b.PortfolioID) === Number(data)
          ? {
              ...b,
              disabled: false,
            }
          : b
      );
      return { ...state };
    }

    case ACTION.FIRM_OVERVIEW_UPDATE: {
      return { ...state, firm: { ...state.firm, ...data } };
    }

    case ACTION.FIRM_LOGO_UPDATE: {
      return { ...state, firm: { ...state.firm, ...data } };
    }

    case ACTION.CANDIDATES_ALSO_VIEWED_FIRM_RATING_UPDATE_REQUEST: {
      state.relativeFirms = state.relativeFirms.map(f =>
        Number(f.FirmID) === Number(data)
          ? {
              ...f,
              disabled: true,
            }
          : f
      );
      return { ...state };
    }

    case ACTION.CANDIDATES_ALSO_VIEWED_FIRM_RATING_UPDATE_FAIL: {
      state.relativeFirms = state.relativeFirms.map(f =>
        Number(f.FirmID) === Number(data)
          ? {
              ...f,
              disabled: false,
            }
          : f
      );
      return { ...state };
    }

    case ACTION.CANDIDATES_ALSO_VIEWED_FIRM_RATING_UPDATE_SUCCESS: {
      state.relativeFirms = state.relativeFirms.map(f =>
        Number(f.FirmID) === Number(data.FirmID)
          ? {
              ...f,
              ...data,
              ShowRating: 'Yes',
              disabled: false,
            }
          : f
      );
      return { ...state };
    }

    case ACTION.FIRM_PORTFOLIO_GRID_REQUEST: {
      return state;
    }

    case ACTION.FIRM_PORTFOLIO_GRID_SUCCESS: {
      state.tabs.portfolio.data[data.type.toLowerCase()] = { ...data.grid };
      return { ...state };
    }

    // portfolio comments
    case ACTION.FIRM_PORTFOLIO_COMMENTS_REQUEST: {
      const { type, id } = data;
      state.tabs.portfolio.data[type].rows = state.tabs.portfolio.data[
        type
      ].rows.map(item =>
        Number(item.PortfolioID) === Number(id)
          ? { ...item, isFetchingComments: true }
          : item
      );
      return { ...state };
    }

    case ACTION.FIRM_PORTFOLIO_COMMENTS_SUCCESS: {
      const { type, id, comments } = data;
      state.tabs.portfolio.data[type].rows = state.tabs.portfolio.data[
        type
      ].rows.map(item =>
        Number(item.PortfolioID) === Number(id)
          ? {
              ...item,
              isFetchingComments: false,
              Comments: item.Comments.length
                ? [...comments, ...item.Comments]
                : [...comments],
            }
          : item
      );
      return { ...state };
    }

    case ACTION.FIRM_PORTFOLIO_COMMENTS_FAIL: {
      const { type, id } = data;
      state.tabs.portfolio.data[type].rows = state.tabs.portfolio.data[
        type
      ].rows.map(item =>
        Number(item.PortfolioID) === Number(id)
          ? { ...item, isFetchingComments: false }
          : item
      );
      return { ...state };
    }

    case ACTION.FIRM_PORTFOLIO_ADD_COMMENT_REQUEST: {
      const { type, id } = data;
      state.tabs.portfolio.data[type].rows = state.tabs.portfolio.data[
        type
      ].rows.map(item =>
        Number(item.PortfolioID) === Number(id)
          ? { ...item, isFetchingComments: true }
          : item
      );
      return { ...state };
    }

    case ACTION.FIRM_PORTFOLIO_ADD_COMMENT_SUCCESS: {
      const { type, id, comment } = data;
      state.tabs.portfolio.data[type].rows = state.tabs.portfolio.data[
        type
      ].rows.map(item =>
        Number(item.PortfolioID) === Number(id)
          ? {
              ...item,
              isFetchingComments: false,
              Comments: item.Comments.length
                ? [...item.Comments, comment]
                : [comment],
              CommentsCount: Number(item.CommentsCount) + 1,
            }
          : item
      );
      return { ...state };
    }

    case ACTION.FIRM_PORTFOLIO_ADD_COMMENT_FAIL: {
      const { type, id } = data;
      state.tabs.portfolio.data[type].rows = state.tabs.portfolio.data[
        type
      ].rows.map(item =>
        Number(item.PortfolioID) === Number(id)
          ? { ...item, isFetchingComments: false }
          : item
      );
      return { ...state };
    }

    case ACTION.FIRM_PORTFOLIO_REMOVE_COMMENT_REQUEST: {
      const { type, id } = data;
      state.tabs.portfolio.data[type].rows = state.tabs.portfolio.data[
        type
      ].rows.map(item =>
        Number(item.PortfolioID) === Number(id)
          ? { ...item, isFetchingComments: true }
          : item
      );
      return { ...state };
    }

    case ACTION.FIRM_PORTFOLIO_REMOVE_COMMENT_SUCCESS: {
      const { type, id, commentId } = data;
      state.tabs.portfolio.data[type].rows = state.tabs.portfolio.data[
        type
      ].rows.map(item =>
        Number(item.PortfolioID) === Number(id)
          ? {
              ...item,
              isFetchingComments: false,
              Comments: item.Comments.filter(
                comment => Number(comment.ID) !== Number(commentId)
              ),
              CommentsCount: Number(item.CommentsCount) - 1,
            }
          : item
      );
      return { ...state };
    }

    case ACTION.FIRM_PORTFOLIO_REMOVE_COMMENT_FAIL: {
      const { type, id } = data;
      state.tabs.portfolio.data[type].rows = state.tabs.portfolio.data[
        type
      ].rows.map(item =>
        Number(item.PortfolioID) === Number(id)
          ? { ...item, isFetchingComments: false }
          : item
      );
      return { ...state };
    }

    // review comments
    case ACTION.FIRM_REVIEW_COMMENTS_REQUEST: {
      const { type, id } = data;
      state.tabs.reviews.data.rows = state.tabs.reviews.data.rows.map(item =>
        Number(item.ReviewID) === Number(id) && item.ReviewType === type
          ? { ...item, isFetchingComments: true }
          : item
      );
      return { ...state };
    }

    case ACTION.FIRM_REVIEW_COMMENTS_SUCCESS: {
      const { type, id, comments } = data;
      state.tabs.reviews.data.rows = state.tabs.reviews.data.rows.map(item =>
        Number(item.ReviewID) === Number(id) && item.ReviewType === type
          ? {
              ...item,
              isFetchingComments: false,
              Comments: item.Comments.length
                ? [...comments, ...item.Comments]
                : [...comments],
            }
          : item
      );
      return { ...state };
    }

    case ACTION.FIRM_REVIEW_COMMENTS_FAIL: {
      const { type, id } = data;
      state.tabs.reviews.data.rows = state.tabs.reviews.data.rows.map(item =>
        Number(item.ReviewID) === Number(id) && item.ReviewType === type
          ? { ...item, isFetchingComments: false }
          : item
      );
      return { ...state };
    }

    case ACTION.FIRM_REVIEW_ADD_COMMENT_REQUEST: {
      const { type, id } = data;
      state.tabs.reviews.data.rows = state.tabs.reviews.data.rows.map(item =>
        Number(item.ReviewID) === Number(id) && item.ReviewType === type
          ? { ...item, isFetchingComments: true }
          : item
      );
      return { ...state };
    }

    case ACTION.FIRM_REVIEW_ADD_COMMENT_SUCCESS: {
      const { type, id, comment } = data;
      state.tabs.reviews.data.rows = state.tabs.reviews.data.rows.map(item =>
        Number(item.ReviewID) === Number(id) && item.ReviewType === type
          ? {
              ...item,
              isFetchingComments: false,
              Comments: item.Comments.length
                ? [...item.Comments, comment]
                : [comment],
              CommentsCount: Number(item.CommentsCount) + 1,
            }
          : item
      );
      return { ...state };
    }

    case ACTION.FIRM_REVIEW_ADD_COMMENT_FAIL: {
      const { type, id } = data;
      state.tabs.reviews.data.rows = state.tabs.reviews.data.rows.map(item =>
        Number(item.ReviewID) === Number(id) && item.ReviewType === type
          ? { ...item, isFetchingComments: false }
          : item
      );
      return { ...state };
    }

    case ACTION.FIRM_REVIEW_REMOVE_COMMENT_REQUEST: {
      const { type, id } = data;
      state.tabs.reviews.data.rows = state.tabs.reviews.data.rows.map(item =>
        Number(item.ReviewID) === Number(id) && item.ReviewType === type
          ? { ...item, isFetchingComments: true }
          : item
      );
      return { ...state };
    }

    case ACTION.FIRM_REVIEW_REMOVE_COMMENT_SUCCESS: {
      const { type, id, commentId } = data;
      state.tabs.reviews.data.rows = state.tabs.reviews.data.rows.map(item =>
        Number(item.ReviewID) === Number(id) && item.ReviewType === type
          ? {
              ...item,
              isFetchingComments: false,
              Comments: item.Comments.filter(
                comment => Number(comment.ID) !== Number(commentId)
              ),
              CommentsCount: Number(item.CommentsCount) - 1,
            }
          : item
      );
      return { ...state };
    }

    case ACTION.FIRM_REVIEW_REMOVE_COMMENT_FAIL: {
      const { type, id } = data;
      state.tabs.reviews.data.rows = state.tabs.reviews.data.rows.map(item =>
        Number(item.ReviewID) === Number(id) && item.ReviewType === type
          ? { ...item, isFetchingComments: false }
          : item
      );
      return { ...state };
    }

    // ...
    default:
      return state;
  }
};
